<script>
import AddressSelect from "../contacts/address-select.vue";

export default {
  name: "form-address",
  data() {
    return {
      address: this.value
    }
  },
  props: {
    withName: Boolean,
    value: Object,
    objkey: {
      type: String,
      default: ''
    },
    noCountry: Boolean,
    state: {
      type: Object,
      default() {
        return {}
      }
    },
    autofocus: Boolean,
    useEnter: Boolean,
    selectUrl: String,
    selectDisabled: Boolean
  },

  watch: {
    address(v) {
      this.$emit('input', v)
    },
    value(v) {
      this.address = v
    }
  },

  methods: {
    keydown(event) {
      return this.useEnter && (event.which === 13)
    },
    focus() {
      this.$refs.address1.focus()
    },
    selectAddress(url) {
      this.$dialog.showAndWait(AddressSelect, {url}).then(v => {
        if (v) {
          if (this.withName)
            ['name', 'company'].forEach(k => this.address[this.objkey + k] = v[k]);

          ['address1', 'address2', 'city', 'state', 'zip', 'country'].forEach(k => this.address[this.objkey + k] = v[k])
        }
      })
    }
  }
}
</script>
<template>
  <div>
    <b-button :disabled="selectDisabled" v-if="selectUrl" variant="link" block class="mb-1 text-right" size="sm" @click="selectAddress(selectUrl)">Select Address</b-button>
    <template v-if="withName">
      <b-input size="sm" placeholder="Name" class="mb-1" :autofocus="autofocus" ref="name"
               :state="state[objkey + 'name'] | state"
               @keydown.native="(e) => keydown(e) && $refs.company.focus()"
               v-model="address[objkey + 'name']"/>
      <b-form-invalid-feedback>
        {{ state[objkey + 'name'] }}
      </b-form-invalid-feedback>

      <b-input size="sm" placeholder="Company" class="mb-1" :autofocus="autofocus" ref="company"
               :state="state[objkey + 'company'] | state"
               @keydown.native="(e) => keydown(e) && $refs.address1.focus()"
               v-model="address[objkey + 'company']"/>
      <b-form-invalid-feedback>
        {{ state[objkey + 'company'] }}
      </b-form-invalid-feedback>

    </template>

    <b-input size="sm" placeholder="Address 1" class="mb-1" :autofocus="autofocus" ref="address1"
             :state="state[objkey + 'address1'] | state"
             @keydown.native="(e) => keydown(e) && $refs.address2.focus()"
             v-model="address[objkey + 'address1']"/>
    <b-form-invalid-feedback>
      {{ state[objkey + 'address1'] }}
    </b-form-invalid-feedback>

    <b-input size="sm" placeholder="Address 2" class="mb-1" ref="address2"
             @keydown.native="(e) => keydown(e) && $refs.city.focus()"
             :state="state[objkey + 'address2'] | state"
             v-model="address[objkey + 'address2']"/>
    <b-form-invalid-feedback>
      {{ state[objkey + 'address2'] }}
    </b-form-invalid-feedback>

    <b-input-group size="sm" class="mb-1">
      <b-input size="sm" placeholder="City" ref="city" v-model="address[objkey + 'city']"
               :state="state[objkey + 'city'] | state"
               @keydown.native="(e) => keydown(e) && $refs.state.focus()"
      />
      <b-input size="sm" placeholder="State" ref="state" v-model="address[objkey + 'state']"
               :state="state[objkey + 'state'] | state"
               @keydown.native="(e) => keydown(e) && $refs.zip.focus()"
      />
      <b-input size="sm" placeholder="Zip" ref="zip" v-model="address[objkey + 'zip']"
               :state="state[objkey + 'zip'] | state"
               @keydown.native="(e) => keydown(e) && $emit('next')"
      />
    </b-input-group>
    <div>
      <div class="invalid-feedback d-block">
        {{ state[objkey + 'city'] }}
      </div>
      <div class="invalid-feedback d-block">
        {{ state[objkey + 'state'] }}
      </div>
      <div class="invalid-feedback d-block">
        {{ state[objkey + 'zip'] }}
      </div>
    </div>
    <b-select
        v-if="!noCountry"
        v-model="address[objkey + 'country']"
        :options="$store.state.settings.defaults.countries"
        :state="state[objkey + 'country'] | state"
    />
    <b-form-invalid-feedback>
      {{ state[objkey + 'country'] }}
    </b-form-invalid-feedback>
  </div>
</template>


<style scoped>

</style>